@switch (status()) {
  @case ('created') {
    <mat-icon
      matTooltip="Kalklyl under skapande"
      style="color: slategrey">pause_circle
    </mat-icon>
  }
  @case ('approved') {
    <mat-icon
      matTooltip="Kalkyl godkänd"
      class="positive">check_circle
    </mat-icon>
  }
  @case ('rejected') {
    <mat-icon
      matTooltip="Kalkyl återförd"
      class="negative">x_circle
    </mat-icon>
  }
  @case ('waiting') {
    <mat-icon
      class="tip"
      matTooltip="Kalylen väntar på godkännande"
      style="color: cornflowerblue">triangle_circle
    </mat-icon>
  }
}